import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducers } from '../../redux/reducers'
import { PolicyModalProps } from '../../models/component'
import search from '../../assets/images/search.svg'
import './searchStyle.css'
import { TABLE_CONFIG_TYPE } from '../../constants/table'
import { POLICY_SEARCH_TABLE_CONFIG } from '../../constants/table/table'
import { useEffect, useState } from 'react'
import * as policyDetailActions from '../../redux/actions/policy.detail.action'
import {
  DisplayDateFormat,
  DisplayStringDateToThaiDateFormat,
  isMaskingData,
  maskingEmail,
  maskingMobileNo
} from '../../helpers/texthelper'
import { PolicyDetailModel } from '../../models/policy'
import errorAlert from '../../assets/images/error-alert.svg'
import { AgentModel } from '../../models/agent'

export const SearchPolicyModal: React.VFC<PolicyModalProps> = ({
  handleOkButton,
  handleCancelbutton,
  isOpenModal
}) => {
  const dispatch = useDispatch()
  const [seachInputData, setseachInputData] = useState('')
  const [isShowPhoneOrEmailWarning, setIsShowPhoneOrEmailWarning] = useState(false)
  const policyDetailData = useSelector((state: RootReducers) => state.policyDetailReducer)
  const loginState = useSelector((state: RootReducers) => state.loginReducer)

  const [formErrors, setFormErrors] = useState<any>({})

  const handleOnChangeSeachInputData = (e: any) => {
    if (e.key === 'Enter') {
      handleSearchPolicyData()
    }
  }

  const handleSelectData = (rowData: PolicyDetailModel) => {
    //console.log(rowData)
    handleOkButton(rowData)
    dispatch(policyDetailActions.resetData())
  }

  const displayColData = (key: string, rowBody: any) => {
    if (key === 'FirstName') return `${rowBody[key]} ${rowBody['LastName']}`
    if (key === 'PolicyFlag') {
      if (rowBody[key] === '1') return 'Renew'
      if (rowBody[key] === '3') return 'New'
    }
    if (
      key === 'EmailAddress' &&
      isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        rowBody['AgentNumber'],
        loginState.account?.agentInfo.AgentUnderAOs
      )
    )
      return maskingEmail(rowBody[key])
    if (
      key === 'MobileNo' &&
      isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        rowBody['AgentNumber'],
        loginState.account?.agentInfo.AgentUnderAOs
      )
    )
      return maskingMobileNo(rowBody[key])
    if (key === 'PaidtoDate') return DisplayStringDateToThaiDateFormat(rowBody[key])
    return rowBody[key]
  }

  const handleSearchPolicyData = () => {
    if (seachInputData.length >= 6) {
      setIsShowPhoneOrEmailWarning(false)
      dispatch(policyDetailActions.getPolicyDetail(seachInputData))
    } else {
      setFormErrors({ ...formErrors, ['searchInput']: true })
    }
  }

  const renderHeader = (header: TABLE_CONFIG_TYPE) => {
    return header.header.map(rowHeader => <th key={rowHeader.id}>{rowHeader.name}</th>)
  }

  const disableButton = (email: any, mobile: any) => {
    if (!email && !mobile) return true
    if (email && email.length > 0) return false
    if (mobile && mobile.length > 0) return false
    return true
  }

  const renderTableBody = () => {
    return policyDetailData?.data?.map((rowBody: any, index: number) => {
      const isDisable = disableButton(rowBody['EmailAddress'], rowBody['MobileNo'])
      if (isDisable && !isShowPhoneOrEmailWarning) {
        setIsShowPhoneOrEmailWarning(true)
      }

      return (
        <tr key={index}>
          {POLICY_SEARCH_TABLE_CONFIG.header.map(column => (
            <td key={column.id}>{displayColData(column.id, rowBody)}</td>
          ))}
          <td className="button">
            <button
              className="confirm-paid-button"
              onClick={() => {
                setseachInputData('')
                handleSelectData(rowBody)
              }}
              disabled={isDisable && !loginState.account?.agentInfo.isBranchStaff}
            >
              เลือกข้อมูล
            </button>
          </td>
        </tr>
      )
    })
  }

  const renderTable = () => {
    return (
      <div className="staff-table-content">
        <table className="table-list">
          <thead>
            <tr>
              {renderHeader(POLICY_SEARCH_TABLE_CONFIG)}
              <th></th>
            </tr>
          </thead>
          <tbody key="tbody">{renderTableBody()}</tbody>
        </table>
      </div>
    )
  }

  useEffect(() => {
    if (isShowPhoneOrEmailWarning) {
      setIsShowPhoneOrEmailWarning(!isShowPhoneOrEmailWarning)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal])

  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        className="modal-search"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(24, 48, 40, 0.9)'
          }
        }}
        ariaHideApp={false}
      >
        <div className="modal-search-content">
          <div>
            <div className="modal-search-header-text">รายการกรมธรรม์ลูกค้า</div>
            <div className="modal-popup-text">
              <div className="search-table">
                <img
                  src={search}
                  alt="search"
                  style={{ position: 'absolute', right: 0 }}
                  onClick={handleSearchPolicyData}
                />
                <input
                  type="text"
                  maxLength={15}
                  placeholder="กรุณาระบุเลขที่กรมธรรม์ (ภาษาอังกฤษตัวพิมพ์ใหญ่)"
                  onChange={e => {
                    setFormErrors({})
                    setseachInputData(e.target.value.toUpperCase())
                  }}
                  onKeyDown={e => {
                    handleOnChangeSeachInputData(e)
                  }}
                  className={`search-table-input ${
                    formErrors['searchInput'] && 'error-border-validate'
                  }`}
                  value={seachInputData}
                />
              </div>
              {formErrors['searchInput'] && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรุณาระบุเลขที่กรมธรรม์ ให้ถูกต้อง
                </div>
              )}
            </div>
          </div>
          <div>{renderTable()}</div>
          <div className="search-data-notfound">
            {!policyDetailData.isError &&
              policyDetailData.data?.length == 0 &&
              `กรมธรรม์ดังกล่าวไม่สามารถชำระเบี้ยประกันได้โปรดตรวจสอบข้อมูลกับ Call Center`}
          </div>
          {isShowPhoneOrEmailWarning && !loginState.account?.agentInfo.isBranchStaff && (
            <div className="add-mobile-message">
              *ไม่สามารถออก eTR ได้ เนื่องจากไม่พบข้อมูลอีเมลหรือเบอร์โทรศัพท์
              กรุณาแจ้งลูกค้าเพิ่มอีเมลหรือเบอร์โทรศัพท์ ผ่าน Omne หรือ Call center
            </div>
          )}
          <div className="modal-popup-group-button">
            <button
              className="close-search-dialog-button"
              onClick={() => {
                setseachInputData('')
                setFormErrors({})
                handleCancelbutton()
              }}
            >
              ปิดหน้าจอ
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
